module.exports = __webpack_public_path__ + "img/title.b863222a.png";